/*
 * OZ 2026-10-14: new product page, slice A1 (the buy box of the default product template).
 * Loaded by layout/theme.liquid on the default product template only.
 *
 * - Rating line under the title, trust bar and reviews band: assets/oz-reviews.js (since 2026-10-22).
 * - Price row (snippets/oz-pdp-price.liquid) and the instalment line (snippets/oz-pdp-trust.liquid)
 *   follow the selected variant. theme.js updates the Save label itself; assets/custom.js the rewards.
 * - Condition cards (snippets/oz-pdp-condition-extra.liquid): price and "Sold out" redone for the
 *   options now selected, over the whole variant list (oz-high-variants.js completes it past 250).
 * - Add to cart shows the running total: the variant plus every protection switch that is on. The
 *   switches are the add-on checkboxes (.related_product_block_check_input; legacy rows or the Upsells
 *   app's in-page rows); assets/oz-buy.js (OzBuy.buy) adds them to the cart with the phone, and
 *   assets/oz-upsells.js re-checks the app rows on a variant change. Nothing here adds to the cart.
 *
 * Reads the product JSON afresh every time: oz-high-variants.js rewrites it after load.
 */
(function () {
  'use strict';

  function sections() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-section-type="product"]')).filter(function (section) {
      return section.querySelector('[data-oz-price]');
    });
  }

  function productData(section) {
    var el = section.querySelector('[data-product-json]');
    if (!el) { return null; }
    try { return JSON.parse(el.textContent || el.innerHTML); } catch (e) { return null; }
  }

  // Store format "${{amount}}": thousands with commas, two decimals.
  function amount(cents) {
    var value = (Math.round(cents) / 100).toFixed(2).split('.');
    return { dollars: value[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','), cents: value[1] };
  }
  function money(cents) {
    var a = amount(cents);
    return '$' + a.dollars + '.' + a.cents;
  }
  // As Liquid's money_without_trailing_zeros: "$679", "$2.88"
  function moneyShort(cents) {
    var a = amount(cents);
    return '$' + a.dollars + (a.cents === '00' ? '' : '.' + a.cents);
  }
  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function selectedOptions(section) {
    var chosen = {};
    section.querySelectorAll('.product-form__single-selector:checked, select.product-form__single-selector').forEach(function (input) {
      chosen[input.getAttribute('data-option-position')] = input.value;
    });
    return chosen;
  }

  function currentVariant(section, data) {
    var form = section.querySelector('form[action*="/cart/add"]');
    var idInput = form && form.querySelector('[name="id"]');
    var id = idInput ? Number(idInput.value) : NaN;
    var variants = (data && data.product && data.product.variants) || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) { return variants[i]; }
    }
    return null;
  }

  /* ---------- price row and instalments ---------- */
  function renderPrice(section, variant) {
    var now = section.querySelector('[data-oz-price-now]');
    if (!now || !variant) { return; }
    var a = amount(variant.price);
    // Design 1: whole-dollar prices show no cents ("$679")
    now.innerHTML = '<span class="visually-hidden">' + escapeHtml((window.languages && window.languages.productSalePrice) || 'Sale price') + '</span>$' +
      a.dollars + (a.cents === '00' ? '' : '<span class="price-cents">.' + a.cents + '</span>');

    var compare = section.querySelector('[data-oz-price-compare]');
    var compareValue = section.querySelector('[data-oz-price-compare-value]');
    if (compare && compareValue) {
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      compare.hidden = !onSale;
      if (onSale) { compareValue.textContent = '$' + amount(variant.compare_at_price).dollars; }
    }

    // the Save pill on the photo (snippets/product-gallery.liquid), worded as theme.js words the Save label
    // two copies: on the photo (phones) and beside the title (desktop)
    section.querySelectorAll('[data-oz-gallery-save]').forEach(function (save) {
      var saving = variant.compare_at_price && variant.compare_at_price > variant.price;
      save.style.display = saving ? '' : 'none';
      if (saving && window.languages && window.languages.collectionOnSaleLabel) {
        var savings = window.theme && window.theme.discountMode === 'percentage'
          ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%'
          : '<span>' + moneyShort(variant.compare_at_price - variant.price) + '</span>';
        save.innerHTML = window.languages.collectionOnSaleLabel.replace('{{savings}}', savings);
      }
    });

    var instalment = section.querySelector('[data-oz-instalment]');
    if (instalment) { instalment.textContent = money(Math.ceil(variant.price / 4)); }
    // PayPal Pay in 4: purchases up to $1,999.99 in Australia
    var paypal4 = section.querySelector('[data-oz-paypal4]');
    if (paypal4) { paypal4.hidden = variant.price >= 200000; }
  }

  /* ---------- condition cards ---------- */
  function renderConditions(section, data) {
    var list = section.querySelector('[data-oz-cond-list]');
    if (!list || !data || !data.product) { return; }
    var position = list.getAttribute('data-option-position');
    var key = 'option' + position;
    var chosen = selectedOptions(section);
    var variants = data.product.variants || [];

    list.querySelectorAll('.block-swatch').forEach(function (swatch) {
      var input = swatch.querySelector('.block-swatch__radio');
      var priceEl = swatch.querySelector('[data-oz-cond-price]');
      var soldEl = swatch.querySelector('[data-oz-cond-sold]');
      if (!input || !priceEl) { return; }
      var value = input.value;
      var exact = null, lowest = null, any = null;
      variants.forEach(function (variant) {
        if (variant[key] !== value) { return; }
        if (any === null || variant.price < any) { any = variant.price; }
        if (!variant.available) { return; }
        if (lowest === null || variant.price < lowest) { lowest = variant.price; }
        var sameOthers = Object.keys(chosen).every(function (pos) {
          return pos === position || variant['option' + pos] === chosen[pos];
        });
        if (sameOthers) { exact = variant.price; }
      });
      var shown = exact !== null ? exact : (lowest !== null ? lowest : any);
      priceEl.textContent = shown === null ? '' : moneyShort(shown);
      if (soldEl) { soldEl.hidden = lowest !== null; }
    });
  }

  /* ---------- add to cart with the running total ---------- */
  function renderTotal(section, variant) {
    var button = section.querySelector('.product-form__add-button[data-action="add-to-cart"]');
    if (!variant) { return; }
    // a sold-out choice still updates the sticky bar (price, configuration, Sold out), like the main button
    if (!button || !variant.available) { renderSticky(section, variant); renderExpress(section, variant); return; }
    var total = variant.price;
    section.querySelectorAll('.related_product_block_check_input:checked').forEach(function (input) {
      total += Number(input.getAttribute('data-price')) || 0;
    });
    var label = (window.languages && window.languages.productFormAddToCart) || 'Add to cart';
    button.innerHTML = escapeHtml(label) + '<span class="oz-atc-suffix"> &middot; <span class="oz-atc-total">' + moneyShort(total) + '</span></span>';
    button.setAttribute('aria-label', label + ', total ' + moneyShort(total));
    renderSticky(section, variant, total);
    renderExpress(section, variant);
  }

  // Express buttons (snippets/product-buy-buttons.liquid): Shop Pay, the Apple Pay / Google Pay wallet and its Checkout
  // stand-in, hidden while the selected option is sold out
  function renderExpress(section, variant) {
    section.querySelectorAll('[data-oz-buy="shop"], [data-oz-buy="checkout"], [data-oz-express] > [data-oz-wallet]').forEach(function (el) {
      if (el.hidden !== !variant.available) { el.hidden = !variant.available; }
    });
  }

  /* ---------- our sticky bar (snippets/oz-sticky-bar.liquid) ----------
   * The HTML is final at load; on a change the total, the configuration and the photo follow, and the bar
   * shows while the main Add to cart is out of view. Its button presses the main one. */
  // a configuration longer than the bar slides to show its end and back (CSS oz-sticky-peek); the distance is
  // the overflow, measured here
  // c is the still text; its parent is the clipping box that carries is-long and the distance, measured on the
  // moving copy (an inline-block as wide as the whole text)
  function fitStickyConfig(c) {
    var box = c.parentElement;
    box.classList.remove('is-long');
    box.style.removeProperty('--oz-shift');
    var move = box.querySelector('[data-oz-sticky-move]');
    var overflow = (move ? move.getBoundingClientRect().width : 0) - box.clientWidth;
    if (overflow > 0.5) {
      box.style.setProperty('--oz-shift', -Math.ceil(overflow + 2) + 'px');
      void box.offsetWidth; // restart the animation from the parked state
      box.classList.add('is-long');
    }
  }

  function renderSticky(section, variant, total) {
    var bar = document.querySelector('[data-oz-sticky]');
    if (!bar || !variant) { return; }
    var data = productData(section);
    var names = (data && data.options_with_values || []).map(function (o) { return o.name; });
    var parts = [bar.getAttribute('data-oz-model')];
    // storage, condition, then every other option (colour, finish, band) in product order
    var order = ['Storage', 'Condition'].concat(names.filter(function (n) { return n !== 'Storage' && n !== 'Condition'; }));
    order.forEach(function (name) {
      var i = names.indexOf(name);
      if (i !== -1 && variant['option' + (i + 1)]) { parts.push(variant['option' + (i + 1)]); }
    });
    var config = parts.filter(Boolean).join(' \u00b7 ');
    var t = bar.querySelector('[data-oz-sticky-total]');
    var c = bar.querySelector('[data-oz-sticky-config]');
    var b = bar.querySelector('[data-oz-sticky-atc]');
    var img = bar.querySelector('[data-oz-sticky-photo]');
    if (t) { t.textContent = moneyShort(typeof total === 'number' ? total : variant.price); }
    if (c && c.textContent !== config) {
      c.textContent = config;
      var move = bar.querySelector('[data-oz-sticky-move]');
      if (move) { move.textContent = config; }
      fitStickyConfig(c);
    }
    if (b) {
      b.disabled = !variant.available;
      b.textContent = variant.available ? ((window.languages && window.languages.productFormAddToCart) || 'Add to cart') : ((window.languages && window.languages.productFormSoldOut) || 'Sold out');
    }
    if (img && variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
      var src = variant.featured_media.preview_image.src.replace(/(\.[a-z]+)(\?|$)/i, '$1$2');
      img.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=96';
    }
  }

  function setUpSticky() {
    var config = document.querySelector('[data-oz-sticky-config]');
    if (config) {
      fitStickyConfig(config);
      window.addEventListener('resize', function () { fitStickyConfig(config); });
    }
    var bar = document.querySelector('[data-oz-sticky]');
    var main = document.querySelector('form.product-form .product-form__add-button');
    if (!bar || !main) { return; }
    bar.querySelector('[data-oz-sticky-atc]').addEventListener('click', function () { main.click(); });
    // the bar shows all the time on phones (Dereck, 2026-10-14: "don't hide the sticky bar")
  }

  /* ---------- guarantee tiles and the included-cover row follow the condition ----------
   * Exceptional: 15 months, 90%+ battery; New: manufacturer's warranty, brand-new battery; the other
   * grades: 12 months, 80%+ (the store's grade definitions). Same texts as the Liquid first paint. */
  // a guarantee's text: all but the last word, then the last word glued to its (i) (snippets/oz-pdp-trust.liquid, 2026-10-17)
  function setGuarantee(el, text) {
    if (!el) { return; }
    var head = el.querySelector('[data-oz-g-head]');
    var tail = el.querySelector('[data-oz-g-tail]');
    if (!head || !tail) { el.textContent = text; return; }
    var k = text.lastIndexOf(' ');
    head.textContent = k > -1 ? text.slice(0, k + 1) : '';
    tail.textContent = k > -1 ? text.slice(k + 1) : text;
  }
  function renderCover(section, data, variant) {
    if (!variant || !data || !data.product) { return; }
    var names = (data.product.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var i = names.indexOf('Condition');
    var cond = i > -1 ? variant['option' + (i + 1)] : '';
    var t = { warranty: '12-month warranty', battery: '80%+ battery', cover: 'Covered for 12 months' };
    if (cond === 'Exceptional') { t = { warranty: '15-month warranty', battery: '90%+ battery', cover: 'Covered for 15 months' }; }
    else if (cond === 'New') { t = { warranty: "Manufacturer's warranty", battery: 'Brand-new battery', cover: "Manufacturer's warranty" }; }
    // Apple Certified Refurbished: sealed, brand-new genuine Apple battery, Apple's own 1-year warranty (Dereck 2026-10-16)
    else if (cond === 'Apple Certified Refurbished') { t = { warranty: '1-year Apple warranty', battery: '100% battery', cover: '1-year Apple warranty' }; }
    setGuarantee(section.querySelector('[data-oz-g-warranty]'), t.warranty);
    setGuarantee(section.querySelector('[data-oz-g-battery]'), t.battery);
    var c = section.querySelector('[data-oz-cover-title]'); if (c) { c.textContent = t.cover; }
  }

  function refresh(section, variant) {
    var data = productData(section);
    var chosen = variant || currentVariant(section, data);
    renderPrice(section, chosen);
    renderConditions(section, data);
    renderTotal(section, chosen);
    renderCover(section, data, chosen);
    orderColours(section);
  }

  function refreshAll() {
    sections().forEach(function (section) { refresh(section); });
  }

  /* rating line and reviews band: assets/oz-reviews.js (2026-10-22) */

  /* ---------- delivery dates under Add to cart ----------
   * Melbourne time (Intl, so daylight saving is handled). An order placed on a weekday before the dispatch
   * cutoff (Melbourne time) is dispatched that day, otherwise on the next business day; standard and express
   * arrive their set number of business days after dispatch. Business days skip Saturdays and Sundays only:
   * public holidays are not counted. The cutoff, the day ranges and the wording are theme settings
   * (Theme settings > OzMobiles delivery, 2026-10-23), handed over by the delivery card's data attributes
   * (snippets/product-buy-buttons.liquid), so there is no second copy here. */
  var DAY = 86400000;
  function deliveryRules() {
    var card = document.querySelector('[data-oz-delivery][data-cutoff]');
    if (!card) { return null; }
    function pair(name) { return String(card.getAttribute(name) || '').split(',').map(function (n) { return parseInt(n, 10); }); }
    return { cutoff: parseInt(card.getAttribute('data-cutoff'), 10), standard: pair('data-standard'), express: pair('data-express'), free: card.getAttribute('data-free') || '' };
  }
  function melbourneNow(at) {
    var parts = {};
    new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Melbourne', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
      .formatToParts(at || new Date()).forEach(function (p) { parts[p.type] = p.value; });
    // A UTC midnight standing for the Melbourne calendar day; all sums below are in whole days.
    return { day: Date.UTC(+parts.year, +parts.month - 1, +parts.day), hour: +parts.hour, minute: +parts.minute };
  }
  function isBusinessDay(day) {
    var weekday = new Date(day).getUTCDay();
    return weekday !== 0 && weekday !== 6;
  }
  function addBusinessDays(day, count) {
    while (count > 0) { day += DAY; if (isBusinessDay(day)) { count--; } }
    return day;
  }
  function dispatchDay(now, cutoff) {
    if (isBusinessDay(now.day) && now.hour * 60 + now.minute < cutoff) { return now.day; }
    return addBusinessDays(now.day, 1);
  }
  var WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function dayLabel(day, withMonth) {
    var d = new Date(day);
    return WEEKDAYS[d.getUTCDay()] + ' ' + d.getUTCDate() + (withMonth ? ' ' + MONTHS[d.getUTCMonth()] : '');
  }
  function range(from, to) {
    var sameMonth = new Date(from).getUTCMonth() === new Date(to).getUTCMonth();
    return dayLabel(from, !sameMonth) + ' to ' + dayLabel(to, true);
  }
  function deliveryText(at) {
    var rules = deliveryRules();
    if (!rules) { return null; }
    var dispatch = dispatchDay(melbourneNow(at), rules.cutoff);
    return {
      standard: rules.free + ' ' + range(addBusinessDays(dispatch, rules.standard[0]), addBusinessDays(dispatch, rules.standard[1])),
      express: 'Express ' + range(addBusinessDays(dispatch, rules.express[0]), addBusinessDays(dispatch, rules.express[1]))
    };
  }
  // The page shows the server's dates (snippets/oz-delivery-dates.liquid); this mirrors those sums so they
  // can be checked from the console: ozDeliveryText(new Date('2026-10-16T08:00:00Z')).
  window.ozDeliveryText = deliveryText;

  /* ---------- Design 1 parity (2026-10-14) ---------- */

  // The Condition "(more info)" link opens the Grading guide accordion (the grading table moved there).
  // Capture phase, and the click stops here: theme.js also scrolls #scrolltoblock to the old #grading anchor
  // (jQuery, on the link itself), and that 1-second animation would win over this scroll. Since 2026-10-15 the
  // Grading guide with videos shows on desktop too, so this runs at every width when it is on the page.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-oz-open-accordion], #scrolltoblock');
    if (!link) { return; }
    var item = document.getElementById(link.getAttribute('data-oz-open-accordion') || 'oz-acc-grading');
    // without a visible Grading guide (from 750px, the html one) the link goes to the grading section, as on live
    if (!item || item.offsetParent === null) { return; }
    event.preventDefault();
    event.stopPropagation();
    var toggle = item.querySelector('.card__collapsible-button');
    if (toggle && toggle.getAttribute('aria-expanded') !== 'true') { toggle.click(); }
    item.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);

  // Gallery on phones: the dots are in the server HTML (snippets/product-gallery.liquid; no counter, Dereck);
  // this only moves them when the selected photo changes.
  function setUpGallery(section) {
    var gallery = section.querySelector('.product-gallery.oz-gallery');
    var carousel = gallery && gallery.querySelector('.product-gallery__carousel');
    if (!carousel || carousel.dataset.ozCounterBound) { return; }
    carousel.dataset.ozCounterBound = 'true';
    var dots = gallery.querySelectorAll('.oz-gallery__dots i');
    function update() {
      var items = carousel.querySelectorAll('.product-gallery__carousel-item');
      var index = -1;
      items.forEach(function (item, i) { if (item.classList.contains('is-selected')) { index = i; } });
      if (index === -1) { return; }
      dots.forEach(function (dot, i) { if (dot.classList.contains('is-on') !== (i === index)) { dot.classList.toggle('is-on', i === index); } });
    }
    if (window.MutationObserver) {
      new MutationObserver(update).observe(carousel, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }
  }

  // Gallery thumbnails on desktop: the column runs the gallery's height (assets/oz-pdp.css) and fades where more
  // thumbnails are hidden. is-more-above / is-more-below on the .scroller, kept current on scroll, on resize and when
  // theme.js filters thumbnails by variant (is-filtered).
  function setUpThumbFade(section) {
    var gallery = section.querySelector('.product-gallery.oz-gallery');
    var list = gallery && gallery.querySelector('.product-gallery__thumbnail-list');
    var scroller = list && list.closest('.scroller');
    if (!scroller || list.dataset.ozFadeBound) { return; }
    list.dataset.ozFadeBound = 'true';
    var queued = false;
    function update() {
      queued = false;
      var top = list.scrollTop;
      var rest = list.scrollHeight - list.clientHeight - top;
      var above = top > 1;
      var below = rest > 1;
      if (scroller.classList.contains('is-more-above') !== above) { scroller.classList.toggle('is-more-above', above); }
      if (scroller.classList.contains('is-more-below') !== below) { scroller.classList.toggle('is-more-below', below); }
    }
    function queue() {
      if (queued) { return; }
      queued = true;
      requestAnimationFrame(update);
    }
    list.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    if (window.ResizeObserver) { new ResizeObserver(queue).observe(list); }
    if (window.MutationObserver) {
      new MutationObserver(queue).observe(list, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }
    update();
  }

  // Colours: in-stock first. The HTML has the order for the selected options; when the condition changes,
  // theme.js re-marks the sold-out colours and this re-orders them (CSS order only, the DOM stays put).
  // In-stock colours first. A folded list (data-oz-sw-fold, 2026-10-16) gets the ranks and oz-fh<c> classes its Liquid
  // printed (snippets/product-variant-selector.liquid, the fold): rank = in stock first, then sold out, each in DOM
  // order; at row length c (5 to 16) it shows 2c - 2 swatches, the chosen one always among them.
  var FOLD_MIN = 5;
  var FOLD_MAX = 16;
  function orderColours(section) {
    section.querySelectorAll('.product-form__option[data-selector-type="color"] .color-swatch-list').forEach(function (list) {
      var swatches = Array.prototype.slice.call(list.querySelectorAll('.color-swatch'));
      if (!list.hasAttribute('data-oz-sw-fold')) {
        swatches.forEach(function (swatch, i) {
          var order = String(swatch.classList.contains('color-swatch--disabled') ? i + 101 : i + 1);
          if (swatch.style.order !== order) { swatch.style.order = order; }
        });
        return;
      }
      var n = swatches.length;
      var ranked = swatches.filter(function (s) { return !s.classList.contains('color-swatch--disabled'); })
        .concat(swatches.filter(function (s) { return s.classList.contains('color-swatch--disabled'); }));
      var chosen = null;
      swatches.forEach(function (s) { var input = s.querySelector('input'); if (input && input.checked) { chosen = s; } });
      var chosenRank = chosen ? ranked.indexOf(chosen) + 1 : 0;
      ranked.forEach(function (swatch, k) {
        var rank = k + 1;
        if (swatch.style.order !== String(rank)) { swatch.style.order = String(rank); }
        for (var c = FOLD_MIN; c <= FOLD_MAX; c++) {
          var shown = 2 * c - 2;
          var hide = n > 2 * c && ((rank > shown && swatch !== chosen) || (chosenRank > shown && rank === shown));
          swatch.classList.toggle('oz-fh' + c, hide);
        }
      });
    });
  }

  // the colour fold's chip: "+N more" opens the rest in place, "Show less" folds it again
  document.addEventListener('click', function (event) {
    var chip = event.target.closest && event.target.closest('[data-oz-sw-more]');
    if (!chip) { return; }
    event.preventDefault();
    var list = chip.closest('[data-oz-sw-fold]');
    if (!list) { return; }
    var open = !list.classList.contains('is-open');
    list.classList.toggle('is-open', open);
    chip.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- wiring ---------- */
  document.addEventListener('variant:changed', function (event) {
    var section = event.target && event.target.closest ? event.target.closest('[data-section-type="product"]') : null;
    if (!section || !section.querySelector('[data-oz-price]')) { return; }
    // theme.js resets the button and the selector classes before it fires this event
    refresh(section, event.detail && event.detail.variant);
  });

  document.addEventListener('change', function (event) {
    if (!event.target.classList || !event.target.classList.contains('related_product_block_check_input')) { return; }
    var section = event.target.closest('[data-section-type="product"]');
    if (section && section.querySelector('[data-oz-price]')) { refresh(section); }
  });

  document.addEventListener('oz:product-json-updated', function () { setTimeout(refreshAll, 0); });

  // Load: nothing is rewritten. The HTML from Liquid is the final first paint; these only listen
  // (gallery swipes, scrolling for the sticky bar) and fetch the reviews feed.
  // Desktop opens the Grading guide on load (Dereck 2026-10-15: "start condition grading panel open on desktop");
  // phones keep every accordion closed
  function openGradingOnDesktop() {
    if (!window.matchMedia('(min-width: 750px)').matches) { return; }
    var toggle = document.querySelector('#oz-acc-grading .card__collapsible-button');
    if (toggle && toggle.getAttribute('aria-expanded') !== 'true') { toggle.click(); }
  }

  /* ---------- "Need help?" card (snippets/product-buy-buttons.liquid, 2026-10-16) ----------
     LiveChat's hours: weekdays in Melbourne (Intl, so AEST and AEDT both hold), opening and closing at the times in
     Theme settings > OzMobiles delivery (9am and 5pm by default), read from the card's data-chat-opens and
     data-chat-closes (minutes after midnight). In hours the line opens the
     LiveChat window; otherwise it stays the link to the contact page. The bubble (#chat-widget-container) is hidden on
     this page (oz-pdp.css) and on phones (theme.css); html.oz-chat-open shows it only while the window is open. */
  var HELP_CONTACT = '/pages/contact-us';
  function chatHours(now) {
    var parts = {};
    new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Melbourne', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
      .formatToParts(now || new Date()).forEach(function (p) { parts[p.type] = p.value; });
    var day = parts.weekday;
    var minutes = parseInt(parts.hour, 10) * 60 + parseInt(parts.minute, 10);
    var card = document.querySelector('[data-oz-help][data-chat-opens]');
    if (!card) { return false; }
    var opens = parseInt(card.getAttribute('data-chat-opens'), 10);
    var closes = parseInt(card.getAttribute('data-chat-closes'), 10);
    return day !== 'Sat' && day !== 'Sun' && minutes >= opens && minutes < closes;
  }
  // LiveChat's own availability ('online' or 'offline') once the widget reports it, so public holidays and early
  // finishes are right; until then the Melbourne clock decides. Test hooks: OzHelpCard.render({ availability: 'offline' })
  // or OzHelpCard.render({ now: new Date(...) }) (the clock only).
  var chatAvailability = null;
  function renderHelpCard(test) {
    test = test || {};
    var availability = test.availability !== undefined ? test.availability : (test.now ? null : chatAvailability);
    var open = availability ? availability === 'online' : chatHours(test.now);
    open = open && !!window.LiveChatWidget;
    // one of three versions shows (snippets/product-buy-buttons.liquid); all three keep their place in the cell
    document.querySelectorAll('[data-oz-help-lines]').forEach(function (box) {
      var state = open ? 'on' : 'off';
      if (box.getAttribute('data-state') !== state) { box.setAttribute('data-state', state); }
    });
  }
  function setAvailability(value) {
    if (value === 'online' || value === 'offline') { chatAvailability = value; renderHelpCard(); }
  }
  function setUpHelpCard() {
    if (!document.querySelector('[data-oz-help-lines]')) { return; }
    renderHelpCard();
    // the hours (before the widget reports) can begin or end while the page is open
    setInterval(function () { renderHelpCard(); }, 60000);
    var tries = 0;
    (function bind() {
      var widget = window.LiveChatWidget;
      if (!widget || typeof widget.on !== 'function') { if (++tries < 40) { setTimeout(bind, 250); } return; }
      widget.on('ready', function (data) { setAvailability(data && data.state && data.state.availability); });
      widget.on('availability_changed', function (data) { setAvailability(data && data.availability); });
      try { var state = widget.get('state'); setAvailability(state && state.availability); } catch (err) {}
      renderHelpCard();
      widget.on('visibility_changed', function (data) {
        document.documentElement.classList.toggle('oz-chat-open', !!data && data.visibility === 'maximized');
      });
    })();
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-oz-help-link][data-oz-chat]');
    if (!link || !window.LiveChatWidget) { return; }
    event.preventDefault();
    document.documentElement.classList.add('oz-chat-open');
    try { window.LiveChatWidget.call('maximize'); } catch (err) {
      document.documentElement.classList.remove('oz-chat-open');
      window.location.href = HELP_CONTACT;
    }
  });
  window.OzHelpCard = { render: renderHelpCard, inHours: chatHours, availability: function () { return chatAvailability; } };

  function start() {
    openGradingOnDesktop();
    setUpHelpCard();
    sections().forEach(function (section) { setUpGallery(section); setUpThumbFade(section); });
    setUpSticky();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
